<template lang="pug">
#course_Info
  .main_container.container
    breadcrumb(v-bind:pageName="pageName")
    nav
      select-btns(
        :programList="programProductGroupList",
        :selectIndex.sync="selectIndex"
      )
    .clear
    .training-camp-card(
      v-for="courseType in courseTypeList",
      :key="courseType.id"
    )
      .row
        .col-12.col-md-3
          .training-camp-image(
            v-if="courseType.photo",
            :style="{ backgroundImage: 'url(' + courseType.photo.image + ')' }"
          )
        .col-12.col-md-9
          .training-camp-info
            .training-camp-title
              img.top-basketball-icon(
                src="@/assets/img/icons/icon_small_basketball.png"
              )
              span.icon-title {{ courseType.name }}
            .training-camp-desc {{ courseType.description }}
            .training-camp-district-wrapper
              .training-camp-district(
                v-for="city in courseType.cities",
                :key="city.id"
              )
                .location(
                  @click="toLocation(district.city, district.id)",
                  v-for="(district, index) in city.districts",
                  :key="district.city + '' + district.id"
                ) {{ district.name }}
                  span(v-if="index != city.districts.length - 1") |
            .btns
              .btn.normal-btn(@click="openContactUsDialog(courseType.name)") 請專員與我聯絡
              .btn.strength-btn(@click="toEnroll(courseType)") 立即報名
  custom-footer
  .custom_dialog(v-if="contactUsDialogShow")
    .dialog_container
      .dialog_close_btn(@click="closeContactUsDialog")
        img(src="@/assets/img/icons/close.svg")
      .dialog_content
        contact-us(:courseMsg="courseMsg")
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import SelectBtns from "@/components/common/SelectBtns";
import ContactUs from "@/components/contacts/ContactUs";
import Breadcrumb from "@/components/common/Breadcrumb";
import { stopScroll, startScroll } from "@/utils/scroll";
import { getProgramProductGroupList } from "@/api/ecommerce";

export default {
  name: "CourseInfo",
  components: {
    "custom-footer": CustomFooter,
    "select-btns": SelectBtns,
    "contact-us": ContactUs,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      pageName: "課程資訊",

      programProductGroupList: [],

      courseTypeList: [],
      selectIndex: 0,
      contactUsDialogShow: false,
      courseMsg: "",

      tempProgram: "",
    };
  },
  created() {
    this.getProgramProductGroupList();
  },
  watch: {
    selectIndex() {
      this.courseTypeList =
        this.programProductGroupList[this.selectIndex].course_types;
    },
    "$route.query.id"() {
      this.programProductGroupList = [];
      this.courseTypeList = [];
      this.selectIndex = 0;
      this.getProgramProductGroupList();
    },
  },
  methods: {
    openContactUsDialog(msg) {
      this.courseMsg = "想體驗" + msg;
      this.contactUsDialogShow = true;
      stopScroll();
    },
    closeContactUsDialog() {
      this.contactUsDialogShow = false;
      startScroll();
    },
    toEnroll(courseType) {
      this.$router.push({
        name: "Enroll",
        params: {
          program: this.tempProgram,
          courseType: courseType.name,
        },
      });
    },
    toLocation(cityId, districtId) {
      this.$router.push({
        name: "Locations",
        query: { id: this.$route.query.id },
        params: {
          programProductGroupSelect: this.selectIndex,
          cityId: cityId,
          districtId: districtId,
        },
      });
    },
    getProgramProductGroupList() {
      this.programProductGroupList = [];
      let params = {
        program: this.$route.query.id,
      };
      getProgramProductGroupList(params).then((response) => {
        let tempList = response.data;
        for (let index in tempList) {
          let temp = tempList[index];
          if (!temp.is_additional) {
            this.programProductGroupList.push(temp);
          }
        }

        if (
          this.programProductGroupList &&
          this.programProductGroupList.length > 0
        ) {
          this.courseTypeList =
            this.programProductGroupList[this.selectIndex].course_types;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/dialog/dialog";

.contant-card {
  height: auto;
}

.custom_dialog {
  .dialog_container {
    max-height: 80%;
    height: 100%;
    width: auto;
    max-width: 900px;
    overflow: hidden;
  }
  .dialog_content {
    margin-top: 40px;
    overflow: scroll;
    height: 100%;
    padding-top: 10px;
    padding-bottom: 50px;
  }
}
#course_Info {
  background-color: $color_bg_white;
}

.training-camp-card {
  width: 100%;
  margin: 20px auto;
  box-shadow: 2px 2px 16px #00000023;
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;

  .training-camp-info {
    font-size: 1rem;
    padding: 1rem 1rem 1rem 0;
    height: 100%;
    position: relative;

    .btns {
      position: absolute;
      float: left;
      bottom: 1rem;
      right: 0;
    }

    .btn {
      margin-right: 1rem;
    }

    .training-camp-title {
      margin-bottom: 15px;
    }

    .training-camp-desc {
      font-size: 14px;
      color: #363636;
      min-height: 7vw;
    }

    .training-camp-district-wrapper {
      right: 1rem;
      width: calc(100% - 1rem);
      padding: 1rem 0;
      border-top: 1px solid $color_gray;
      min-height: 72px;
      margin-top: 1rem;

      .training-camp-district {
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        font-size: 16px;
        color: #547edc;
        line-height: 26px;
        padding-right: 220px;

        a {
          color: #547edc;
          text-decoration: underline;
        }

        span {
          margin: 0 5px;
        }
      }
    }
  }

  .training-camp-image {
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 100%;
    min-height: 15vw;
  }
}

.location {
  cursor: pointer;
  text-decoration: underline;
  color: $color_water_blue;
}

@media (max-width: 767px) {
  .training-camp-card {
    .training-camp-image {
      height: 68vw;
    }

    .training-camp-info {
      padding: 1rem;

      .training-camp-district-wrapper {
        margin-top: 1rem;
        position: relative;
        bottom: 0;
        right: 0;
        width: 100%;
        padding-bottom: 0;
        min-height: 50px;
      }
    }
  }
}

@media (max-width: 575px) {
  .custom_dialog {
    .dialog_container {
      position: relative;
      margin: 0 auto;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 10px;
    }
  }
  .training-camp-card {
    .training-camp-image {
      height: 85vw;
    }

    .training-camp-info {
      .training-camp-district-wrapper {
        .training-camp-district {
          padding-right: 1rem;
        }
      }

      .btns {
        position: relative;
        float: none;
        top: 0;
        margin-top: 10px;
      }
    }
  }
}
</style>
